import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('hot_springs', {
  cherry: 'towel',
  lemon: 'sake_cup',
  orange: 'stone_stack',
  bell: 'spring_bell',
  star: 'snow_monkey_wild',
  seven: 'spring_pool',
  gem: 'aqua_gem',
  scatter: 'steam_scatter',
  money: 'spring_hoard',
});

/** Hot Springs — GENERATED by scaffoldSlot from
 *  content/slots/hot_springs.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const HOT_SPRINGS_THEME: Theme = {
  id: 'hot_springs',
  name: 'Hot Springs',
  palette: {
    accent: 0x5fb8b0,
    secondary: 0xa8e0d8,
    warm: 0xf2d27a,
    frameFill: 0x1a2826,
    bgGradientTop: 0x2c4742,
    bgGradientBottom: 0x0c1816,
    dimOverlay: 0x060f0d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Towel', glyph: '🧖', tint: 0xe8b85a, weight: 5, textureAlias: 'hot_springs:cherry',
        winVideoAlias: 'hot_springs:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Tea Set', glyph: '🍵', tint: 0xe0d0b0, weight: 5, textureAlias: 'hot_springs:lemon',
        winVideoAlias: 'hot_springs:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Hot Stones', glyph: '🪨', tint: 0x9a7a5a, weight: 4, textureAlias: 'hot_springs:orange',
        winVideoAlias: 'hot_springs:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Spring Bell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'hot_springs:bell',
        winVideoAlias: 'hot_springs:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Snow Monkey', glyph: '🐵', tint: 0xc8a888, weight: 2, textureAlias: 'hot_springs:star',
        winVideoAlias: 'hot_springs:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Hot Spring', glyph: '♨️', tint: 0x5fb8b0, weight: 2, textureAlias: 'hot_springs:seven',
        winVideoAlias: 'hot_springs:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Aqua Gem', glyph: '💎', tint: 0x5fb8b0, weight: 2.5, textureAlias: 'hot_springs:gem',
        winVideoAlias: 'hot_springs:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Steam Cloud', glyph: '💨', tint: 0xdfeae8, weight: 0.5, textureAlias: 'hot_springs:scatter',
        winVideoAlias: 'hot_springs:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Spring Hoard', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'hot_springs:money',
        winVideoAlias: 'hot_springs:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x5fb8b0, multiplier: 1, weight: 5 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x5fb8b0, multiplier: 1, weight: 5 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xa8e0d8, multiplier: 3, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x1-c', kind: 'multiplier', label: '×1', tint: 0x5fb8b0, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x2-c', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xa8e0d8, multiplier: 3, weight: 3 },
      { id: 'x1-d', kind: 'multiplier', label: '×1', tint: 0x5fb8b0, multiplier: 1, weight: 4 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xf2d27a, multiplier: 10, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'hot_springs:bg', path: 'environment/hot_springs.png' },
      columnBackground: { alias: 'hot_springs:column_bg', path: 'reel/hot_springs_column_bg.png' },
      border: { alias: 'hot_springs:border', path: 'brand/border_frost.png' },
    },
  },
};
